/** @jsx jsx */
import React from 'react'

import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { metrics } from '../../../__styling/settings/metrics'

import { jsx } from '@emotion/react'
import { ThemeMargins } from '../../../__styling/settings/metrics'
import { useConsentGiven } from '@news-mono/web-common'
import { ConsentLevel } from '@news-mono/web-common'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'

export interface OmnyProps {
    link: string
    width?: number
    verticalSpacing?: keyof ThemeMargins
    height?: number
}

const embedLink = '/embed'

const processEmbedLink = (link: string) => {
    if (link.indexOf(embedLink) === -1) {
        return `${link}${embedLink}`
    }
    return link
}

export const isOmny = (link: string) => {
    return link.indexOf('omny.fm') >= 0
}

function isPlaylistEmbed(link: string) {
    return link.indexOf('playlists') !== -1
}

export function omnyHeightValue(props: OmnyProps): string {
    if (isPlaylistEmbed(props.link)) {
        return '500px'
    }

    if (!isPlaylistEmbed(props.link) && props.height) {
        return `${props.height}px`
    }

    return '180px'
}

export const Omny: React.FC<OmnyProps> = (props) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    return (
        <iframe
            css={{
                marginBottom:
                    props.verticalSpacing &&
                    calcRem(metrics.thewest.margins[props.verticalSpacing]),
            }}
            width={props.width ? `${props.width}px` : '100%'}
            height={omnyHeightValue(props)}
            frameBorder={0}
            src={processEmbedLink(props.link)}
            sandbox={'allow-same-origin allow-popups allow-scripts'}
        />
    )
}
